import React from "react";
import { Link } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';

const PaymentOptions = props => {
    return <div className={"container-fluid body-content payment-options-container"}>
        <div className="row">
            <div className="col-12 maxWidth-content">
                <div className="row">
                    <div className="col-12">
                        <h1 className="page-heading">Payment Options</h1>
                        <h2 className="page-subheading">Pay Before Your Visit</h2>
                    </div>
                    <div className="col-12 payment-option">
                        <div className="row row-card-eq">
                            <div className="col-12 col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-12 payment-option__icon">
                                                <div className="icon-call payment-option__icon-color" />
                                            </div>
                                            <div className="col-12 card-heading">
                                                Pay by Phone
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <p> Contact our Pre-Registration department Monday through Friday: 8:00AM To 5:00PM  </p>
                                                <p><span className="call">Call:  </span><a className="phone-link" href={"tel:" + props.customerServicePhone}>{props.customerServicePhone}</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-12 payment-option__icon">
                                                <div className="icon-pay-in-person payment-option__icon-color" />
                                            </div>
                                            <div className="col-12 card-heading">
                                                Pay in Person
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <p> Pay when you arrive in person for your visit. </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-4">
                                <div className="card">
                                    <div className="coming-soon">COMING SOON</div>
                                    <div className="card-header">
                                        <div className="row">
                                            <div className="col-12 payment-option__icon">
                                                <div className="icon-globe payment-option__icon-color" />
                                            </div>
                                            <div className="col-12 card-heading">
                                                Pay Online
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12">
                                                <p> Soon you can pay in advance of your visit directly in MyBSWHealth </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row pay-after-visit hidden">
            <div className="col-12 maxWidth-content">
                <div className="row">
                    <div className="col-12">
                        <div className="pay-after-visit__pay-after">Pay After Your Visit</div>
                        <div className="pay-after-visit__pay-online">
                            Pay online or check your account balance after your visit
                                <Link to={{ pathname: "/accountsummary" }} onClick={() => logUI("MBHWeb.UI.BillingTile.LinkClicked", new Date(), Tools.getURLPath())}> in the billing section</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}


function mapStateToProps(state, ownProps) {
    return {
        customerServicePhone: state.session.serverData.pricingPreRegPhone,
    };
}
export default connect(mapStateToProps)(PaymentOptions);
